import { render, staticRenderFns } from "./InventoryLotSelect.vue?vue&type=template&id=283ed7ca&lang=pug"
import script from "./InventoryLotSelect.vue?vue&type=script&lang=js"
export * from "./InventoryLotSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports